import * as React from 'react';
import * as _ from 'lodash';
import * as  moment from 'moment';
import chartColors from '../../../const/chartColors';
import { Environment } from '../../../const/environment';
import { convertCost } from '../../pages/billing/BillingChart/prepareBillingChartData';

type BillingCharTTooltipProps = {
    active?, payload?
}


const ConsumptionChartTooltipLine = ({ cost = 0, showCost = false, value = 0, label, color }) => {
    return (
        <div className="stats-tooltip__line">
            <span>
                <span className="tooltip-legend-rect" style={{ backgroundColor: color }}></span> {value} {label}
            </span>

            <span>{showCost ? `$${convertCost(cost, true)}` : ''}</span>
        </div>
    );
};

const ConsumptionChartTooltip = ({ active, payload }: BillingCharTTooltipProps) => {

    if (active && payload && payload[0] && payload[0].payload) {
        const data = payload[0].payload;

        return (
            <div className="stats-tooltip">
                <div className="stats-tooltip_time">
                    <b>{moment(data.date).format('MMM D')}</b>  {data.cost ? <b>{<span style={{ backgroundColor: '#ffa600', borderRadius: '50%', marginRight: '2px', width: '8px', minWidth: '8px', maxWidth: '8px', height: '8px', minHeight: '8px', maxHeight: '8px', display: 'inline-block' }}></span>}{'$' + convertCost(data.cost, true)}</b> : <b></b>}
                </div>
                <ConsumptionChartTooltipLine value={data.interValue} cost={data.interCost} showCost={data.showCost} label="Interactions" color={chartColors[Environment.Staging].color6} />
                <ConsumptionChartTooltipLine value={data.indexValue} cost={data.indexCost} showCost={data.showCost} label="Indexing MB" color={chartColors[Environment.Staging].color0} />
            </div>
        );
    }
    return null;
};

export default ConsumptionChartTooltip;
